export const stylesRefs = {
  scheduleHeader: 'Header_scheduleHeader',
  scheduleHeaderSticky: 'Header_scheduleHeaderSticky',
  scheduleHeaderCellSticky: 'Header_scheduleHeaderCellSticky',
  scheduleHeaderBorder: 'Header_scheduleHeaderBorder',
} as const
